import moment from "moment";
import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import Collapse from "@mui/material/Collapse";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import Typography from "@mui/material/Typography";

import {
	ordersRowHistoryColumns,
	orderStatusTranslationConformity,
} from "./common";

export default function OrdersRowHistory({ open, orderHandleTacts }) {
	return (
		<React.Fragment>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box sx={{ margin: 1 }}>
							<Typography variant="h6" gutterBottom component="div">
								Історія
							</Typography>
							<Table size="small" aria-label="purchases">
								<TableHead>
									<TableRow>
										{ordersRowHistoryColumns.map((column) => (
											<TableCell
												key={column.id}
												align={column.align}
												style={{ minWidth: column.minWidth }}
											>
												{column.label}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{orderHandleTacts.map((historyRow) => (
										<TableRow key={historyRow.id}>
											<TableCell>
												{orderStatusTranslationConformity[
													historyRow.newStatus
												] ===
													orderStatusTranslationConformity.ASSEMBLY_FINISHED &&
												historyRow.npCodes &&
												historyRow.npCodes.length > 0
													? orderStatusTranslationConformity.MARKED_TTN
													: orderStatusTranslationConformity[historyRow.newStatus]}
											</TableCell>
											<TableCell>{historyRow.user?.name}</TableCell>
											<TableCell>{historyRow.user?.role}</TableCell>
											<TableCell>
												{historyRow.npCodes &&
													historyRow.npCodes.length > 0 && (
														<Box>
															
															{historyRow.npCodes.map((code) => (
																<Typography>{code}</Typography>
															))}
														</Box>
													)}
											</TableCell>
											<TableCell>{historyRow.comment}</TableCell>
											<TableCell>
												{moment(historyRow.createdAt).format("DD MMM HH:mm")}
											</TableCell>
											{/* <TableCell component="th" scope="row">
												{historyRow.date}
											</TableCell> */}
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</React.Fragment>
	);
}
